import React from 'react';
import { colorSet, theme } from '@components/Provider';
import {
  ButtonProps,
  FormControlLabelProps,
  PropTypes
} from '@material-ui/core';
import { Enum_Action_Button_Enum } from '@hooks/useUserActionLog';

export type TCustomizedButtonColor = 'default' | 'success' | 'error' | 'dark';
export type TButtonColorProp = PropTypes.Color | TCustomizedButtonColor;
export interface ICustomizedButtonProps extends Omit<ButtonProps, 'color'> {
  logId?: Enum_Action_Button_Enum;
  color?: TButtonColorProp;
  underline?: boolean;
}

export const MuiButtonProps = {
  default: {
    palette: {
      secondary: {
        light: colorSet.gray200,
        main: colorSet.gray300,
        dark: colorSet.gray400,
        contrastText: colorSet.gray900
      }
    },
    style: {
      containedSecondary: {
        backgroundColor: colorSet.gray200,
        '&:disabled': {
          color: colorSet.gray500,
          backgroundColor: colorSet.gray200
        }
      },
      outlinedSecondary: {
        color: colorSet.gray900,
        border: `1px solid ${colorSet.gray600}`,
        '&:hover': {
          backgroundColor: colorSet.gray100,
          color: colorSet.gray900,
          border: `1px solid ${colorSet.gray600}`
        },
        '&:disabled': {
          border: `1px solid ${colorSet.gray500}`,
          color: colorSet.gray400
        }
      },
      textSecondary: {
        color: colorSet.gray900
      }
    }
  },
  success: {
    palette: {
      secondary: theme.palette.success
    },
    style: {
      outlinedSecondary: {
        border: `1px solid ${colorSet.successMain}`
      }
    }
  },
  dark: {
    palette: {
      secondary: {
        light: colorSet.gray200,
        main: colorSet.gray900,
        dark: colorSet.gray1000,
        contrastText: colorSet.gray000
      }
    },
    style: {
      containedSecondary: {
        backgroundColor: colorSet.gray900,
        '&:disabled': {
          color: colorSet.gray500,
          backgroundColor: colorSet.gray200
        },
        '&:hover': {
          backgroundColor: colorSet.gray1000
        }
      },
      outlinedSecondary: {
        border: `1px solid ${colorSet.gray900}`,
        '&:hover': {
          backgroundColor: colorSet.gray100
        }
      }
    }
  },
  error: {
    palette: { secondary: theme.palette.error },
    style: {
      outlinedSecondary: {
        border: `1px solid ${colorSet.errorMain}`
      }
    }
  }
};

export type TCustomizedCheckBoxColor = 'default' | 'success' | 'error';
export type TCheckBoxColorProp = 'primary' | 'secondary' | 'default';
export interface ICustomizedCheckBoxProps
  extends Omit<
    FormControlLabelProps,
    'control' | 'value' | 'onChange' | 'label'
  > {
  label?: React.ReactNode;
  value: string;
  values?: Array<string>;
  control?: React.ReactElement<any, any>;
  color?: TCheckBoxColorProp;
  fullwidth?: boolean;
  gutterBottoms?: number;
  size?: 'small' | 'medium';
  onChange: (value: Array<string>) => void;
}
